export default __webpack_public_path__ + "static/resorts-world-41fbf92edf0f7b106f1e74c963c669a3.png";